import script from "./text-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./text-message.vue?vue&type=script&lang=ts&setup=true"

import "./text-message.vue?vue&type=style&index=0&id=1e1db25e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1db25e"]])

export default __exports__